import {
    TYPEDOCUMENT_ERROR, TYPEDOCUMENT_LOADING,
    TYPEDOCUMENTS_UPDATE, TYPEDOCUMENT_UPDATE, TYPEDOCUMENT_ADD_LOADING, FILE_TYPE_UPDATE, TYPEDOCUMENT_ADD_SUCCESS,TYPEDOCUMENT_SCHEMA
} from "../actions/typeDocumentsActions";
import _ from 'lodash';

const INITIAL_STATE = {
    typeDocuments: [],
    typeDocumentsPagination: null,
    typeDocumentsLoading: false,
    typeDocumentsError: null,
    fileTypes: [],
    typeDocumentLoading: false,
    typeDocumentSchemaId: null,
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case TYPEDOCUMENT_ADD_SUCCESS:
            const new_document = action.payload.data;
            const typedocuments = {...state.typeDocuments, [new_document.id]: new_document};
            return { ...state, typeDocuments: typedocuments };
        case TYPEDOCUMENT_ADD_LOADING:
            return {
                ...state,
                typeDocumentLoading: action.payload,
            };
        case TYPEDOCUMENTS_UPDATE:
            return {
                ...state,
                typeDocuments: _.mapKeys(action.payload.data, "id"),
                typeDocumentsPagination: action.payload.pagination,
                typeDocumentsError: action.payload.message,
            };
        case TYPEDOCUMENT_UPDATE:
            const document = action.payload.data;
            const type_documents = {...state.typeDocuments, [document.id]: document};
            return { ...state, typeDocuments: type_documents };
        case TYPEDOCUMENT_ERROR:
            return {
                ...state,
                typeDocumentsError: action.payload,
            };
        case TYPEDOCUMENT_LOADING:
            return {
                ...state,
                typeDocumentsLoading: action.payload,
            };
        case FILE_TYPE_UPDATE:
            return {
                ...state,
                fileTypes: [...INITIAL_STATE.fileTypes, ...action.payload.data],
            };
        case TYPEDOCUMENT_SCHEMA:
            return { ...state, typeDocumentSchemaId: action.payload };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/app/documents/reducers/TypeDocumentsReducer.js